import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
import { FaUser, FaChevronRight, FaLock } from "react-icons/fa";
import AlertMessage from "./AlertMessage";

export const Loginpage = ({ handleSignUpMode }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [alertMessage, setAlertMessage] = useState("");

  const navigate = useNavigate();

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setAlertSeverity("warning");
      setAlertMessage("Please fill in all fields.");
      setAlertOpen(true);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/login`,
        {
          username,
          password,
        }
      );

      if (response.data.success) {
        const role = response.data.role;

        setAlertSeverity("success");
        setAlertMessage(`Welcome, ${role}!`);
        setAlertOpen(true);

        localStorage.setItem("username", username);
        Cookies.set("token", response.data.token, { secure: true, sameSite: "Strict" });

        setTimeout(() => {
          navigate(`/${role.toLowerCase()}`, {
            state: { username, role },
          });
        }, 1000);
      } else {
        setAlertSeverity("error");
        setAlertMessage("Invalid credentials");
        setAlertOpen(true);
      }
    } catch (error) {
      console.error("Error during login:", error);
      setAlertSeverity("error");
      setAlertMessage("Login failed. Please try again.");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signinheading">
      <h2 className="title">Sign in</h2>

      <div className="ss-container">
        <form className="sign-in-form" onSubmit={handleLogin}>
          <div className="ss-card">
            <div className="login__field">
              <FaUser />
              <input
                type="text"
                placeholder="Mobile Number"
                className="login_input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="login__field">
              <FaLock />
              <input
                type="password"
                placeholder="Password"
                className="login_input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button type="submit" className="button login__submit">
              {loading ? "Logging in..." : "Login"}
              <FaChevronRight />
            </button>
          </div>

          <p className="social-text">
            If you don't have an account?{" "}
            <button
              type="button"
              className="btn-signup"
              style={{ background: "none" }}
              onClick={handleSignUpMode}
            >
              Sign up
            </button>
          </p>

          <Link to="/for" style={{ textDecoration: "none" }}>
            <p className="forget-pass">Forget Password?</p>
          </Link>

          <p>
            Go to <Link to="/">Homepage</Link>
          </p>

          <AlertMessage
            open={alertOpen}
            severity={alertSeverity}
            message={alertMessage}
            handleClose={handleAlertClose}
          />
        </form>
      </div>
    </div>
  );
};
